module.exports = "<button (click)=\"presentPopover()\">Subscribe</button>>\n"